<template>
  <div class="main kort"></div>
</template>

<script>
export default {

}
</script>

<style>
.kort{
    background-image: url('https://firebasestorage.googleapis.com/v0/b/fyrtoejet-eb6bc.appspot.com/o/Kort%20til%20spil.png?alt=media&token=ce075bb3-b519-491b-9f4e-d7a6f2e1ff70');
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 0;
    z-index: 1;
}
</style>